import React from 'react';
import { useCvData } from '../context/CvDataContext.js';
import './About.css';

const About = () => {
  const { personalInfo, loading, error, reload } = useCvData();
  if (error) return (
    <section className="about-section" id="about">
      <h2>About Me</h2>
      <p role="alert">{error.message || 'Failed to load.'}</p>
      <button onClick={reload} className="retry-btn">Retry</button>
    </section>
  );
  if (loading) return (
    <section className="about-section" id="about">
      <h2>About Me</h2>
      <div className="skeleton skeleton-text lg" style={{ width: '60%' }} />
      <div className="skeleton skeleton-text" style={{ width: '90%' }} />
      <div className="skeleton skeleton-text" style={{ width: '85%' }} />
      <div className="skeleton skeleton-text" style={{ width: '70%' }} />
    </section>
  );
  if (!personalInfo?.summary) return null;
  return (
    <section className="about-section" id="about">
      <h2>About Me</h2>
      <p>{personalInfo.summary}</p>
    </section>
  );
};

export default About;
